<template>
    <div>
        <notification-modal :vuexStore="vuexStore" :firstAction="firstAction" :firstActionText="firstActionText" :messageTitle="messageTitle" :message="message" :notificationType="notificationType" :resetVariable="resetVariable"></notification-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data () {
        return {
            vuexStore: 'inactivity',
            messageTitle: 'Session Expiring',
            notificationType: 'warning',
            firstAction: 'continueSession',
            firstActionText: '&nbsp;&nbsp;&nbsp;Continue&nbsp;Session&nbsp;&nbsp;&nbsp;',
            resetVariable: 'showWarning'
        }
    },
    computed: {
        ...mapState('inactivity', ['countdown']),
        message () {
            const s = this.countdown === 1 ? '' : 's'
            return `Your session will expire in <strong>${this.countdown}</strong> second${s}.`
        }
    }
}
</script>